import styled from "styled-components"

export const CountdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    align-items: center;
`

export const CountdownHeading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: normal;
    color: #000000;
    text-align: center;
    white-space: nowrap;
`

export const CountdownNumbersWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    flex-wrap: wrap;
    width: 100%;
`

export const CountdownNumber = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    background-color: var(--organization-primary-color-1);
    border-radius: 0.5rem;
    padding: 0.75rem 0.5rem;
    min-width: 5rem;
    text-align: center;
    color: var(--organization-primary-color-0);

    .number {
        font-family: "Roboto", sans-serif;
        font-size: 2rem;
        font-weight: 700;
        line-height: 1;
        color: var(--organization-primary-color-0);
    }

    .label {
        font-family: "Roboto", sans-serif;
        font-size: 12px;
        font-weight: 500;
        text-transform: uppercase;
        line-height: normal;
        color: var(--organization-primary-color-0);
        letter-spacing: 0.5px;
    }
`

export const Separator = styled.div`
    height: 1.09rem;
    width: 0.276rem;
    flex-shrink: 0;
    color: #ced4da;

    svg {
        display: block;
        width: 100%;
        height: 100%;
        max-width: none;
    }
`
